import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import ArrayHelper from 'foundation/array-helper';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { getPlayerSitecoreData } from 'general/js/helpers';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import { bemClasses, LivePreMessage } from 'components/live-pre-message';
import { playerSitecoreData } from 'components/live-player';
import LeaderboardAlphaList from './components/leaderboard-alpha-list';
import LeaderboardContainer from './leaderboard-container';

class LeaderboardLayout extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.subscribe(endpointNames.PLAYERS);
        ScoringLoader.subscribe(endpointNames.LEADERBOARD);
        ScoringLoader.subscribe(endpointNames.COURSE);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.unsubscribe(endpointNames.PLAYERS);
        ScoringLoader.unsubscribe(endpointNames.LEADERBOARD);
        ScoringLoader.unsubscribe(endpointNames.COURSE);
    }

    isPlayOffMode() {
        return this.props.scoringLeaderboard.players.some((player) => {
            return (player.sitecoreData &&
                (player.sitecoreData.playOffStatus ||
                    player.sitecoreData.suddenDeathtatus ||
                    player.sitecoreData.isChampion));
        });
    }

    hasChampion() {
        return this.props.scoringLeaderboard.players.some((player) => {
            return player.sitecoreData && player.sitecoreData.isChampion;
        });
    }

    render() {
        const {
            liveScanner,
            scoringLeaderboard,
            scoringCourse,
            sitecorePlayers,
            options
        } = this.props;

        if (liveScanner === undefined ||
            sitecorePlayers === undefined ||
            scoringCourse === undefined ||
            scoringLeaderboard === undefined
        ) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        const config = get(liveScanner, 'liveComponents.leaderboard');

        if (!config.show ||
            !liveScanner.activeRoundId ||
            !sitecorePlayers ||
            !scoringCourse ||
            !scoringLeaderboard ||
            ArrayHelper.isEmpty(scoringCourse.courseRounds)
        ) {
            const messageModel = {
                title: config.title,
                body: config.subtitle,
                textColor: config.textColor
            };
            return <LivePreMessage
                model={messageModel}
                bemList={[bemClasses.LIGHT, bemClasses.NTT]}
                patronLogo = {options.patronLogo}
            />;
        }

        if (ArrayHelper.isEmpty(scoringLeaderboard.players)) {
            return <LeaderboardAlphaList players={sitecorePlayers.players} />;
        }

        const isPlayOffMode = this.isPlayOffMode();
        const hasChampion = this.hasChampion();

        return (
            <LeaderboardContainer
                options={options}
                liveScanner={liveScanner}
                scoringCourse={scoringCourse}
                scoringLeaderboard={scoringLeaderboard}
                isPlayOffMode={isPlayOffMode}
                hasChampion={hasChampion}
            />
        );
    }
}

LeaderboardLayout.propTypes = {
    options: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    const sitecorePlayers = state.scoring[endpointNames.PLAYERS];
    const scoringLeaderboard = state.scoring[endpointNames.LEADERBOARD];

    if (sitecorePlayers === undefined) return {};

    // inject player sitecore data from players feed
    if (sitecorePlayers &&
        scoringLeaderboard &&
        !ArrayHelper.isEmpty(scoringLeaderboard.players)
    ) {
        scoringLeaderboard.players.forEach((player) => {
            player.sitecoreData =
                getPlayerSitecoreData(sitecorePlayers, player.id) ||
                playerSitecoreData;
        });
    }

    return ({
        liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
        scoringCourse: state.scoring[endpointNames.COURSE],
        scoringLeaderboard,
        sitecorePlayers,
    });
};

const LeaderboardLayoutWrapper = connect(
    mapStateToProps,
    null
)(LeaderboardLayout);

export default LeaderboardLayoutWrapper;
